import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { FlaskConical, Loader2 } from "lucide-react";

/** One tiny completion through the shared layer only — proves this deployment can run AI without its own key. */
export function NetworkTestCard() {
    const [provider, setProvider] = useState("anthropic");
    const [busy, setBusy] = useState(false);
    const [result, setResult] = useState(null);
    const run = async () => {
        setBusy(true); setResult(null);
        try {
            const { data } = await api.post("/admin/llm-network/test", { provider });
            setResult({ ok: true, ...data });
            toast.success(`Served by ${data.served_by}${data.cache_hit ? " (cached)" : ""}`);
        } catch (e) {
            const detail = formatApiErrorDetail(e?.response?.data?.detail);
            setResult({ ok: false, detail });
            toast.error(`Network test failed: ${detail}`);
        } finally {
            setBusy(false);
        }
    };
    return (
        <div className="bg-[#0a0a0a] border border-white/10 rounded-md p-6" data-testid="network-test-card">
            <div className="flex items-center gap-2 mb-1">
                <FlaskConical className="w-4 h-4 text-[#7C3AED]" strokeWidth={1.5} />
                <div className="font-display text-lg tracking-tight">Test the shared network</div>
            </div>
            <p className="text-xs text-white/50 mb-3">Sends a one-word prompt through the network only (local keys bypassed) and reports which environment's credential answered.</p>
            <div className="flex flex-wrap items-center gap-2 text-xs">
                <select value={provider} onChange={(e) => setProvider(e.target.value)} className="rounded border border-white/10 bg-[#050505] px-3 py-1.5 text-white" data-testid="network-test-provider">
                    <option value="anthropic">Anthropic (Claude)</option>
                    <option value="openai">OpenAI</option>
                    <option value="gemini">Google Gemini</option>
                </select>
                <button disabled={busy} onClick={run} className="inline-flex items-center gap-1.5 rounded bg-white text-black px-3 py-1.5 font-medium hover:bg-white/90 disabled:opacity-40" data-testid="network-test-btn">
                    {busy && <Loader2 className="w-3.5 h-3.5 animate-spin" />} Run test completion
                </button>
            </div>
            {result && (
                <div className={`mt-3 rounded border px-3 py-2 text-xs ${result.ok ? "border-emerald-400/30 bg-emerald-400/5 text-emerald-100" : "border-rose-400/30 bg-rose-400/5 text-rose-200"}`} data-testid="network-test-result">
                    {result.ok
                        ? <>Served by <span className="font-mono" data-testid="network-test-served-by">{result.served_by}</span> · {result.model} · {result.latency_ms} ms · ${Number(result.cost_usd || 0).toFixed(5)}{result.cache_hit ? " · cached" : ""}{result.failed_over?.length ? ` · failed over from ${result.failed_over.length}` : ""} · reply “{result.reply}”</>
                        : result.detail}
                </div>
            )}
        </div>
    );
}
